(ns practitest.frontend.components2.grid.row-menu
  (:require [reagent.core :as reagent]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.components.card-view]))

(defn row-menu [_ disabled-action-menu? menu-items & _]
  (let [local-state (reagent/atom {})
        root-container (atom nil)]
    (fn [_ disabled-action-menu? menu-items & [{:keys [tooltip placement flip?]}]]
      (let [show-dropdown? (reagent/cursor local-state [:show-dropdown?])
            hide-dropdown! #(reset! show-dropdown? false)
            toggle-dropdown! #(swap! show-dropdown? not)

            show-confirmation? (reagent/cursor local-state [:show-confirmation?])
            hide-confirmation! #(swap! local-state assoc :show-confirmation? false)
            show-confirmation! (fn [details]
                                 (swap! local-state assoc
                                        :confirmation-details details
                                        :show-confirmation? true))

            menu-items menu-items]
        [:div.action-menu-button
         {:class (dom/classes-pairs-v :disabled disabled-action-menu?)
          :ref (dom/root-ref-handler root-container)}
         [practitest.frontend.components.card-view/confirmation-dialog
          show-confirmation?
          (reagent/cursor local-state [:confirmation-details])]
         [practitest.frontend.components.card-view/dropdown-menu
          {:show?      show-dropdown?
           :container  root-container
           :toggle!    toggle-dropdown!
           :hide!      hide-dropdown!
           :disabled?  disabled-action-menu?
           :tooltip    tooltip
           :placement  placement
           :flip?      flip?
           :menu-items (for [item menu-items
                             :when (some? item)]
                         [practitest.frontend.components.card-view/menu-item
                          {:hide!              hide-dropdown!
                           :show-confirmation! show-confirmation!
                           :hide-confirmation! hide-confirmation!}
                          item])}]]))))
